import { render, staticRenderFns } from "./Technologies.vue?vue&type=template&id=806401bc&scoped=true&"
import script from "./Technologies.vue?vue&type=script&lang=js&"
export * from "./Technologies.vue?vue&type=script&lang=js&"
import style0 from "./Technologies.vue?vue&type=style&index=0&id=806401bc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806401bc",
  null
  
)

export default component.exports